"use client";

import BlogCard from "@/components/ui/Card/BlogCard";
import { motion } from "framer-motion";

export function Blog() {
  return (
    <div className="bg-white dark:bg-[#171420] mt-4 py-10 mb-20 relative">
      <div className="container color-home before:top-[1000px]">
        <div className="text-center">
          <motion.span
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.3, ease: "easeInOut" }}
            viewport={{ once: true }}
            className="text-xl text-main-green font-medium"
          >
            Chia sẻ
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.4, ease: "easeInOut" }}
            viewport={{ once: true }}
            className="text-primary dark:text-[#45c3dc] text-4xl lg:text-5xl font-bold mb-16 mt-4 uppercase"
          >
            Blog của tôi
          </motion.h1>
        </div>
        <div className="grid grid-cols-2 gap-8">
          {Array.from({ length: 4 }).map((index) => (
            <BlogCard key={"index" + index} />
          ))}
        </div>
      </div>
    </div>
  );
}
